import { IChartApi, ISeriesApi } from "lightweight-charts";
import { VertLine } from "source/lib/lightweight-charts-plugins/vertical-line/vertical-line";

export function AddVerticalLinesToChart(
    chart: IChartApi,
    series: ISeriesApi<any>
) {
    const linesToAdd: { time: string; labelText: string }[] = [
        { time: "2020-09-03", labelText: "6.5?" },
        { time: "2021-12-08", labelText: "the fall" },
        { time: "2023-01-16", labelText: "7.0?" },
        { time: "2024-09-02", labelText: "?" },
    ];

    linesToAdd.forEach((line) =>
        AddVerticalLineToChart(chart, series, line.time, line.labelText)
    );
}

function AddVerticalLineToChart(
    chart: IChartApi,
    lineSeries: ISeriesApi<any>,
    time: string,
    labelText: string
) {
    const vertLine = new VertLine(chart, lineSeries, time, {
        showLabel: true,
        labelText,
    });

    lineSeries.attachPrimitive(vertLine);
}
